import { Box, Typography } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel/index.js";
import { styled } from "@mui/material/styles";
const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  marginLeft: theme.spacing(0.5),
  fontFamily: "Lato",
  fontWeight: 400,
  fontSize: "16px",
  fontStyle: "normal",
  lineHeight: "22px",
  letterSpacing: "0.5px",
  color: theme.palette.grey[800]
}));
const InfoBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(2),
  color: theme.palette.grey[800]
}));
const InfoText = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[800]
}));
export {
  InfoBox,
  InfoText,
  StyledFormControlLabel
};
